import { PartyPopper } from "lucide-react";
import { Reveal, ChapterHeading } from "./Reveal";

const Anniversary = () => (
  <section className="py-24 sm:py-32 bg-sand-dark/50" data-testid="anniversary-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-12 gap-14 items-center">
      <div className="lg:col-span-6 order-2 lg:order-1">
        <Reveal>
          <div className="absolute -bottom-6 -right-6 w-full h-full rounded-3xl bg-mint/60" aria-hidden="true" />
          <div className="relative overflow-hidden rounded-3xl shadow-[0_20px_50px_rgb(0,0,0,0.1)]">
            <img
              src="/photos/anniversary.jpg"
              alt="Before and after: the Me 1st Fitness & Coaching studio being built, then finished — 4th anniversary"
              className="w-full object-cover"
              data-testid="anniversary-image"
            />
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-6 order-1 lg:order-2">
        <ChapterHeading number="02" label="Milestone" title="Four Years Strong" />
        <Reveal delay={0.1}>
          <p className="mt-7 text-base sm:text-lg leading-relaxed text-charcoal/70 max-w-xl">
            From an empty room under construction to a fully equipped studio — Me 1st Fitness
            &amp; Coaching recently celebrated its 4th anniversary in Red Deer.
          </p>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-charcoal/70 max-w-xl">
            Every dumbbell, every mat, every square foot was built with one purpose: a welcoming
            place where everyday people put themselves first.
          </p>
          <p
            className="mt-8 inline-flex items-center gap-3 rounded-full bg-charcoal text-sand font-bold px-6 py-3 text-sm"
            data-testid="anniversary-badge"
          >
            <PartyPopper size={18} className="text-brand" />
            Celebrating 4 years in Red Deer
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Anniversary;
